import { Link } from 'react-router';
import type { ReactNode } from 'react';

// Club-branded top bar, shown on every page (admin, kiosk, login).
//
// title/subtitle split mirrors the sister project's rebrand (MyHours): a
// short product name always shown, a descriptive line hidden below the
// `sm` breakpoint where there's no room for a second line.
export default function BrandBar({
  title,
  subtitle,
  to,
  children,
}: {
  title: string;
  subtitle?: string;
  to: string;
  children?: ReactNode;
}) {
  return (
    <div className="top-bar">
      <Link to={to} className="brand">
        <img className="brand-logo" src="/club-logo.png" alt="SpVgg Lagerlechfeld-Graben e. V." />
        <span className="brand-text">
          <span className="brand-title">{title}</span>
          {subtitle && <span className="brand-subtitle">{subtitle}</span>}
        </span>
      </Link>
      {children}
    </div>
  );
}
